export enum AircraftSelectorType {
  TailNumber = 'tailNumber',
  Registration = 'registration',
}
